export default {
  'register-invoiced': 'Registrar datos de facturación',
  'assign-products': 'Asignar inspector',
  'request-inspection': 'Solicitar inspección en sitio para este pedimento',
  'assign-out-of-customs-date': 'Asignar fecha de desaduanamiento',
  'upload-paid-petition': 'Subir pedimento pagado',
  'validate-products': 'Validar/cancelar productos ante S.E.',
  'edit-service': 'Editar servicio'
};
